module.exports = __webpack_public_path__ + "static/media/virtual-terminal.14cdcfd8.png";